<template lang="pug">
  v-card(style="border-radius: 4px;")
    v-card-text
      v-form(ref="form")
        p(v-if="edit").title.text-xs-center.pt-3 Это поле не редактируется!
        div(v-else)
          v-text-field(
          v-model="field.fieldNameRU",
          label="Название поля (RU, KG)")
          v-text-field(
          v-model="field.fieldNameEN",
          label="Название поля (EN)")
    v-card-actions.pb-4
      v-spacer
      v-btn(color="primary", @click.prevent="cancel" v-if="edit") Закрыть
      v-btn(color="primary", @click.prevent="create", v-if="!edit").create-btn Создать
      v-spacer
</template>

<script>
import nanoid from 'nanoid'
export default {
  name: 'Map',
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    editField: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    field: {
      fieldNameRU: 'Карта',
      fieldNameEN: 'map'
    }
  }),
  methods: {
    create() {
      const id = `map-${nanoid()}`
      let data = {
        id: id,
        schema: {
          type: 'input',
          inputType: 'text',
          label: this.field.fieldNameRU,
          label_ru: this.field.fieldNameRU,
          label_kg: this.field.fieldNameRU,
          label_en: this.field.fieldNameEN,
          model: id,
          autocomplete: 'off',
          disabled: true
        }
      }
      this.$emit('create-field', data)
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card__actions {
    .v-btn {
      border-radius: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Constructor/components/Map.vue